$(document).ready(function () {
    $("form").on("mouseenter", ".info-switch", function () {
        $("#" + $(this).data("info")).fadeIn();
    });
    $("form").on("mouseleave", ".info-switch", function () {
        $("#" + $(this).data("info")).fadeOut();
    });

    App.addSelectPlaceholderClass();
    App.datepicker(".datepicker");

    $("input#created").daterangepicker({
        autoUpdateInput: false,
        timePicker: true,
        timePicker24Hour: true,
        locale: {
            format: "DD/MM/YYYY HH:mm",
            cancelLabel: "Clear",
        },
    });
    $("input#created").on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
    });
    $("input#created").on("apply.daterangepicker", function (e, picker) {
        picker.element.val(
            picker.startDate.format(picker.locale.format) +
                picker.locale.separator +
                picker.endDate.format(picker.locale.format)
        );
    });

    /*
     *	Add the corresponding button colour, action and text.
     *	Also add/remove the corresponding div
     */
    $("body").on("click", ".btn-credit-line", function (e) {
        if ($(this).attr("action") === "add") {
            var values = $(".credit-precedent-line-item")
                .map(function (index, el) {
                    return parseInt($(el).attr("index"));
                })
                .get();
            var index = Math.max.apply(null, values);
            var data = {
                index: index + 1,
            };
            $.get(
                "/admin/credit-precedents/add-credit-precedent-line-item",
                data
            ).done(function (data) {
                $(".line-place-holder").last().replaceWith(data);
                $("html, body").animate(
                    {
                        scrollTop: parseInt(
                            $(".line-item-hr").eq(-2).offset().top
                        ),
                    },
                    1000
                );
            });
        } else {
            /*	Always leave one section	*/
            if ($(".credit-precedent-line-item").length === 1) {
                return;
            }

            /*	Delete the section	*/
            $(this).parent(".credit-precedent-line-item").remove();
            updateCreditValues();
        }
    });

    $("body").on("click", ".btn-bulk-update", function (e) {
        if (
            confirm(
                "Are you sure you want to update all of the selected precedents?"
            )
        ) {
            return true;
        } else {
            return false;
        }
    });

    $("body").on(
        "change",
        ".credit-value, #course-mapping-internal-course-credits",
        function (e) {
            updateCreditValues();
        }
    );

    $("body").on("change", "#update-type", function (e) {
        console.info($(this).val());
        switch ($(this).val()) {
            case "1":
                $("#status-id").parents(".input").first().show();
                $("#expiry-date").parents(".input").first().hide();
                $("#expiry-date").removeAttr("required");
                $("#status-id").attr("required", "required");
                $(".btn-bulk-update").show();
                $(".btn-bulk-update").removeAttr("disabled");
                $(".btn-bulk-delete").hide();
                break;
            case "2":
                $("#status-id").parents(".input").first().hide();
                $("#expiry-date").parents(".input").first().show();
                $("#status-id").removeAttr("required");
                $("#expiry-date").attr("required", "required");
                $(".btn-bulk-update").show();
                $(".btn-bulk-delete").hide();
                $(".btn-bulk-update").removeAttr("disabled");
                break;
            case "3":
                $("#status-id").parents(".input").first().show();
                $("#expiry-date").parents(".input").first().show();
                $("#status-id").attr("required", "required");
                $("#expiry-date").attr("required", "required");
                $(".btn-bulk-update").show();
                $(".btn-bulk-delete").hide();
                $(".btn-bulk-update").removeAttr("disabled");
                break;
            case "4":
                $("#status-id").parents(".input").first().hide();
                $("#expiry-date").parents(".input").first().hide();
                $("#status-id").removeAttr("required");
                $("#expiry-date").removeAttr("required");
                $(".btn-bulk-update").hide();
                $(".btn-bulk-delete").show();
                $(".btn-bulk-update").attr("disabled", "disabled");
                break;
            default:
                $("#status-id").parents(".input").first().hide();
                $("#expiry-date").parents(".input").first().hide();
                $("#status-id").removeAttr("required");
                $("#expiry-date").removeAttr("required");
                $(".btn-bulk-update").show();
                $(".btn-bulk-delete").hide();
                $(".btn-bulk-update").attr("disabled", "disabled");
                break;
        }
    });

    $("body").on("change", "#send-notification", function (e) {
        switch ($(this).val()) {
            case "Y":
                $("#email-recipients").parents(".input").first().show();
                $("#email-recipients").change();
                $("#index-btn").hide();
                break;
            case "N":
                $("#email-recipients").parents(".input").first().hide();
                $("#notification-preview").hide();
                $("#index-btn").show();
                break;
            default:
                $("#email-recipients").parents(".input").first().hide();
                $("#notification-preview").hide();
                $("#index-btn").hide();
                break;
        }
    });

    $("body").on("change", "#email-recipients", function (e) {
        if ($("#email-recipients").val() !== "") {
            $("#recipient-email").html($("#email-recipients").val());
            $("#notification-preview").show();
        } else {
            $("#notification-preview").hide();
        }
    });

    $("#update-type").change();
    updateCreditValues();
});

function updateCreditValues() {
    var courseCredit = Number(
        $("#course-mapping-internal-course-credits").val()
    );
    var precedentCredit = $(".credit-value")
        .map(function () {
            return !isNaN(Number(this.value)) ? Number(this.value) : 0;
        })
        .get()
        .reduce((a, b) => a + b, 0);
    var remainingCredit = Math.max(0, courseCredit - precedentCredit);

    $("#course-credit-points").html("Course Credit Points: " + courseCredit);
    $("#precedent-credit-points").html(
        "Precedent Credit Points: " + precedentCredit
    );
    $("#remaining-credit-points").html(
        "Remaining Credit Points: " + remainingCredit
    );
}

/**
 * Collection of the generic Javascript functions for the application
 *
 * @type array
 */
var App = {
    /**
     * Add style class for select input placeholders
     *
     * @returns void
     */
    addSelectPlaceholderClass: function _addSelectPlaceholderClass() {
        var inputSelector = "select";

        // Update color based on selected option
        $(inputSelector).change(function () {
            $(inputSelector).each(function () {
                var selectInput = $(this);

                selectInput.find("option").addClass("normal-option");
                if (selectInput.find("option:first-child").val() === "") {
                    selectInput
                        .find("option:first-child")
                        .removeClass("normal-option")
                        .addClass("placeholder-option");
                }
                if (selectInput.val()) {
                    selectInput.removeClass("placeholder-text");
                } else {
                    selectInput.addClass("placeholder-text");
                }
            });
        });

        // Asign correct color on page load
        $(inputSelector).change();
    },

    /**
     * Add datepicker to an input selector
     *
     * @returns void
     */
    datepicker: function _datepicker(selector) {
        $(selector).datepicker({
            dateFormat: "dd-mm-yy",
        });
    },
};

var CreditLines = {
    /**
     * Check the selected credit type to disable/enable related fields
     *
     * @param options object containing id options
     * @returns void
     */
    setDisplayFields: function _setPrecedentLineDisplayFields(options) {
        var creditTypeInput = $("#" + options.creditTypeInput);
        var ruleDiv = $("#" + options.ruleDiv);
        var unitInput = $("#" + options.unitInput);
        var studyMeasureDiv = $("#" + options.studyMeasureDiv);
        var unitCode1Input = $("#" + options.unitCode1Input);
        var unitCode2Input = $("#" + options.unitCode2Input);
        var operatorInput = $("#" + options.operatorInput);

        operatorInput.change(function () {
            if (operatorInput.val() == "UCB") {
                unitCode2Input.parent().show();
                unitCode1Input.parent().removeClass("col-sm-7");
                unitCode1Input.parent().addClass("col-sm-4");
                unitCode2Input.attr("required", "required");
            } else {
                unitCode2Input.parent().hide();
                unitCode1Input.parent().removeClass("col-sm-4");
                unitCode1Input.parent().addClass("col-sm-7");
                unitCode2Input.removeAttr("required");
            }
        });

        creditTypeInput.change(function () {
            $.get(
                "/admin/credit-types/get-Credit-Type-Code-By-Id/" +
                    creditTypeInput.val(),
                function (data) {
                    var creditTypeCode = data.creditTypeCode;

                    if (creditTypeCode == "E" || creditTypeCode == "D") {
                        ruleDiv.show();
                        ruleDiv.find(":input").attr("required", "required");
                        studyMeasureDiv.show();
                        studyMeasureDiv
                            .find(":input")
                            .attr("required", "required");
                        unitInput.parent().parent().hide();
                        unitInput
                            .parent()
                            .parent()
                            .find(":input")
                            .removeAttr("required");
                        if (ruleDiv.find(".rule-criteria").val() == "UCB") {
                            unitCode2Input.attr("required", "required");
                        } else {
                            unitCode2Input.removeAttr("required");
                        }
                    } else if (creditTypeCode == "X") {
                        ruleDiv.hide();
                        ruleDiv.find(":input").removeAttr("required");
                        studyMeasureDiv.hide();
                        studyMeasureDiv.find(":input").removeAttr("required");
                        unitInput.parent().parent().show();
                        unitInput
                            .parent()
                            .parent()
                            .find(":input")
                            .attr("required", "required");
                    } else {
                        ruleDiv.hide();
                        ruleDiv.find(":input").removeAttr("required");
                        studyMeasureDiv.hide();
                        studyMeasureDiv.find(":input").removeAttr("required");
                        unitInput.parent().parent().hide();
                        unitInput
                            .parent()
                            .parent()
                            .find(":input")
                            .removeAttr("required");
                    }
                }
            );
        });

        creditTypeInput.change();
        operatorInput.change();
    },

    /**
     * Copy unit id to precedent line unit id for unit mapping
     *
     * @param options object containing id options
     * @returns void
     */
    copyUnitToPrecedentLine: function _copyUnitToPrecedentLine(options) {
        var mappingUnitIdInput = $("#" + options.mappingUnitIdInput);
        var lineUnitIdInput = $("#" + options.lineUnitIdInput);

        mappingUnitIdInput.change(function () {
            lineUnitIdInput.val(mappingUnitIdInput.val());
        });
    },
};

/**
 * Collection of Javascript functions for the mapping configuration process
 *
 * @type array
 */
var Mapping = {
    /**
     * Current index to generate new mappings
     */
    currentIndex: 0,

    /**
     * Check the RPL checkboxes to disable/enable related fields
     *
     * @param options object containing id options
     * @returns void
     */
    checkRPL: function _checkRPL(options) {
        var rplRequiredInput = $("#" + options.rplRequiredInput);
        var rplRequiredNotesInput = $("#" + options.rplRequiredNotesInput);
        var rplOnlyInput = $("#" + options.rplOnlyInput);
        var externalUnitInput = $("#" + options.externalUnitInput);
        var externalUnitDescriptionInput = $(
            "#" + options.externalUnitDescriptionInput
        );

        rplRequiredInput.change(function () {
            if (rplRequiredInput.is(":checked")) {
                rplOnlyInput.prop("checked", false);
                rplOnlyInput.change();
                rplRequiredNotesInput.parent().parent().children().show();
            } else {
                rplRequiredNotesInput.parent().parent().children().hide();
            }
        });

        rplOnlyInput.change(function () {
            if (rplOnlyInput.is(":checked")) {
                rplRequiredInput.prop("checked", false);
                rplRequiredInput.change();

                externalUnitInput.prop("disabled", true);
                externalUnitDescriptionInput.prop("disabled", true);
            } else {
                externalUnitInput.prop("disabled", false);
                externalUnitDescriptionInput.prop("disabled", false);
            }
        });

        // Execute the logic the first time to set the fields in the correct status after the binding
        rplRequiredInput.change();
        rplOnlyInput.change();
    },

    /**
     * Set an input autocomplete
     *
     * @param string valueInputSelector Selector for the input to store the real value
     * @param string textInputSelector Selector for the input to type the code to search
     * @param string descriptionInputSelector Selector for the input to display the organisation description
     * @param string url data provider url
     * @returns void
     */
    autocomplete: function _autocomplete(
        valueInputSelector,
        textInputSelector,
        descriptionInputSelector,
        url
    ) {
        $(textInputSelector).change(function () {
            if ($(textInputSelector).val() == "") {
                $(valueInputSelector).val(0).change();
                $(descriptionInputSelector).val("").change();
            }
        });

        $(textInputSelector).typeahead({
            source: function (query, process) {
                $(valueInputSelector).val(0).change();
                $(descriptionInputSelector).val("").change();
                return $.get(
                    url + ".json?search=" + query.toUpperCase(),
                    function (data) {
                        return process(data);
                    }
                );
            },
            updater: function (item) {
                $(valueInputSelector).val(item.id);
                $(valueInputSelector).change();
                $(descriptionInputSelector).val(item.description).change();
                return item;
            },
            afterSelect: function (item) {
                $(textInputSelector).val(item.code);
            },
            displayText: function (item) {
                return item.displayName != undefined
                    ? item.displayName
                    : item.code;
            },
            autoSelect: true,
            items: 10,
        });
    },

    autocompleteIntSpkInput: function _autocompleteIntSpkInput(
        valueInputSelector,
        textInputSelector,
        descriptionInputSelector,
        creditField,
        url
    ) {
        $(textInputSelector).change(function () {
            if ($(textInputSelector).val() == "") {
                $(valueInputSelector).val(0).change();
                $(creditField).val(0).change();
                $(descriptionInputSelector).val("").change();
            }
        });

        $(textInputSelector).typeahead({
            source: function (query, process) {
                $(valueInputSelector).val(0).change();
                $(descriptionInputSelector).val("").change();
                return $.get(
                    url + ".json?search=" + query.toUpperCase(),
                    function (data) {
                        return process(data);
                    }
                );
            },
            updater: function (item) {
                $(valueInputSelector).val(item.id);
                $(valueInputSelector).change();
                $(descriptionInputSelector).val(item.description).change();
                $(creditField).val(item.credits).change();
                return item;
            },
            afterSelect: function (item) {
                $(textInputSelector).val(item.code);
                $(textInputSelector).attr("value", item.code);
            },
            displayText: function (item) {
                return item.displayName != undefined
                    ? item.displayName
                    : item.code;
            },
            autoSelect: true,
            items: 10,
        });
    },

    autocompleteExtSpk: function _autocompleteExtSpk(
        extOrgInput,
        valueInputSelector,
        textInputSelector,
        descriptionInputSelector,
        url
    ) {
        $(textInputSelector).typeahead({
            source: function (query, process) {
                $(valueInputSelector).val(0).change();
                $(descriptionInputSelector).val("").change();
                return $.get(
                    url +
                        ".json?extOrgId=" +
                        $(extOrgInput).val() +
                        "&search=" +
                        query.toUpperCase(),
                    function (data) {
                        return process(data);
                    }
                );
            },
            updater: function (item) {
                $(valueInputSelector).val(item.id);
                $(valueInputSelector).change();
                $(descriptionInputSelector).val(item.description).change();
                return item;
            },
            afterSelect: function (item) {
                $(textInputSelector).val(item.code);
            },
            displayText: function (item) {
                return item.displayName != undefined
                    ? item.displayName
                    : item.code;
            },
            autoSelect: true,
            items: 10,
        });
    },

    autocompleteContact: function (rootSelector, prefix, type, url) {
        $(rootSelector + " .text-input").typeahead({
            source: function (query, process) {
                return $.get(
                    url + ".json?type=" + type + "&search=" + query,
                    function (data) {
                        return process(data);
                    }
                );
            },
            updater: function (item) {
                $(prefix + "-id")
                    .val(item.id)
                    .change();
                $(prefix + "-email")
                    .val(item.email)
                    .change();
                $(prefix + "-phone")
                    .val(item.phone)
                    .change();
                $(prefix + "-fax")
                    .val(item.fax)
                    .change();
                $(prefix + "-website")
                    .val(item.website)
                    .change();
                $(prefix + "-role")
                    .val(item.role)
                    .change();
                return item;
            },
            displayText: function (item) {
                return (
                    item.email +
                    " " +
                    item.phone +
                    " " +
                    item.fax +
                    " " +
                    item.role +
                    " " +
                    item.website
                );
            },
            autoSelect: true,
            items: 10,
        });
        $(rootSelector + " .btn-clear").on("click", function (e) {
            $(rootSelector + " .contact-id").removeAttr("value");
            $(rootSelector + " .form-control").val("");
        });
    },

    /**
     * Add a new External Organization item to the credit precedents form
     *
     * @param string creditMappingTypeId credit mapping type
     */
    addExtOrgUnitItem: function _addExtOrgUnitItem(creditMappingTypeId) {
        this.currentIndex++;
        var data = {
            index: this.currentIndex,
            credit_mapping_type_id: creditMappingTypeId,
        };
        var currentIndex = this.currentIndex;
        $.get("/admin/credit-precedents/add-ext-org-unit-item", data)
            .done(function (data) {
                $(".ext-org-unit-item").last().replaceWith(data);
                $("html, body").animate(
                    {
                        scrollTop: parseInt(
                            $(".ext-org-unit-item").eq(-2).offset().top
                        ),
                    },
                    1000
                );
            })
            // Apply TinyMCE to new precedent information textarea
            .done(function () { applyToNewTextarea(currentIndex); });
    },

    removeExtOrgUnitItem: function _removeExtOrgUnitItem(extOrgUnitItem) {
        if ($(".btn-ext-org-unit").length == 1) {
            return;
        }
        $("#" + extOrgUnitItem).remove();
    },

    clearExtSpkInputs: function _clearExtSpkInputs(options) {
        var inputField = $("#" + options.inputField);

        inputField.change(function () {
            $(".ext-spk-input").val("").change();
        });
    },
};

var CreditCalc = window.CreditCalc = {
    autocomplete: function (textInputSelector, url) {
        $(textInputSelector).typeahead({
            source: function (query, process) {
                return $.get(url + ".json?search=" + query, function (data) {
                    return process(data);
                });
            },
            updater: function (item) {
                $(textInputSelector).val(item.code + " - " + item.description);
                return item;
            },
            displayText: function (item) {
                return item.code + " - " + item.description;
            },
            // autoSelect: true,
            items: 10,
        });
    },
};
